import * as React from 'react';

interface Props {
    draftPreview: string;
    appliedPreview: string;
    isValid: boolean;
}

export const AdvancedFilterRawPreview: React.FC<Props> = ({
    draftPreview,
    appliedPreview,
    isValid,
}) => {
    const preview = isValid && draftPreview ? draftPreview : appliedPreview;

    if (!preview) {
        return null;
    }

    return (
        <div className="c-advanced-filter__preview">
            <div className="c-advanced-filter__preview-header">
                <label className="c-advanced-filter__preview-label">
                    Generert filter
                </label>
            </div>
            {!isValid && appliedPreview && (
                <div className="c-advanced-filter__errors">
                    <p className="c-advanced-filter__error">
                        Filteret er ugyldig, bruker sist anvendte
                    </p>
                </div>
            )}
            <code className="c-advanced-filter__preview-code">{preview}</code>
        </div>
    );
};
